var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPinFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H65V65H0z",
    transform: "translate(-765 -358) translate(285 140) translate(480 218)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-765 -358) translate(285 140) translate(480 218)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.25,
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.5,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 24.125,
    fill: "#1E2447",
    stroke: "#1E2447",
    strokeWidth: 0.5,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32.5V32.5H0z",
    transform: "translate(16.25 16.25)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.25 16.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 16.25,
    r: 16.25,
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 16.25,
    r: 5.417,
    fill: "#FFF"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinFull);
export default __webpack_public_path__ + "static/media/map-pin-full.e136d7bd.svg";
export { ForwardRef as ReactComponent };